/*=========================================================================================
  File Name: module-invoicefiles-state.js
  Description: InvocieFile Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {};
